<template>
    <div class="pt-8">
        <FilterForm 
            :filter="filter" 
            @get-attributes-list-empresa="getAttributesListEmpresa()" 
            @clear-filter-form="clearFilterForm()" 
        />

        <AttributesTable 
            :attributes="attributes" 
            :paginator="paginator" 
            :pageSize="pageSize"  
            @get-attributes-list-empresa="getAttributesListEmpresa()" 
            @change-page="changePage($event)" 
            @update-status-attribute="updateStatusAttribute($event)"
        />
    </div>

</template>
<script>
import { mapMutations } from 'vuex'
import FilterForm from '../components/FilterForm.vue'
import AttributesTable from '../components/AttributesTable.vue'
export default {
    data(){
        return{
            attributes: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            filter: {
                nombre: '',
                codigo: '',
            }
        }
    },
    components: {
        FilterForm,
        AttributesTable
    },
    created(){
        this.getAttributesListEmpresa();
    },
    methods:{ 
        ...mapMutations(['setLoading']),
        async getAttributesListEmpresa(){
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize:   this.paginator.pageSize,
                nombre:     this.filter.nombre,
                codigo:     this.filter.codigo
            }
            this.setLoading(true)
            await this.$conectar.post('/empresa/attributes/get-attributes-list-empresa', this.pageOptions)
            .then(response =>{
                this.attributes = response.data.attributesListEmpresa;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getAttributesListEmpresa();
        },
        async updateStatusAttribute(item){
            //change the value from the database, with the new one because bootstrap and vue don't change it on v-model
            item.status = !item.status
            this.data = {attribute_id: item.id, status: item.status}
            this.setLoading(true)
            await this.$conectar.post('/empresa/attributes/update-status-attribute', this.data)
            .then(response =>{
                if(response.data.error == true){
                    item.status = !item.status;
                    this.$bvToast.toast(response.data.errorMessage, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e);
                item.status = !item.status;
                this.$bvToast.toast("Parece que hubo un error en el servidor, por favor intente mas tarde, si el problema persiste, contacte al administrador.", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                
            })
            this.setLoading(false)
        },
        clearFilterForm(){
            this.filter.nombre = "";
            this.filter.codigo = "";
        }
    }
}
</script>